import React, { Component } from 'react';
import Switch from '../Part_Sample/Switch';
import Select from '../Part_Sample/Select';
import Editbox from '../Part_Sample/Editbox';

export default class Command_Level extends Component {
	constructor(props) {
		super(props);

		this.min = 0;
		this.max = 100;
		if (this.props.point_info != null) {
			this.min = this.props.point_info.limit[0];
			this.max = this.props.point_info.limit[1];
		}

		this.state = {
			is_enabled: this.props.action_details.av != null ? true : false,
			av: this.props.action_details.av != null ? this.props.action_details.av : this.min
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		let is_enabled = false;

		if (nextProps.action_details.av != null) is_enabled = true;
		if (is_enabled != nextState.is_enabled) {
			this.setState({
				is_enabled: is_enabled,
			})
		}

		let av = nextProps.action_details.av != null ? nextProps.action_details.av : this.min

		if (av != nextState.av) {
			this.setState({
				av: av
			})
		}
		return true;
	}

	handleToggleEnable = () => {
		let is_enabled = !this.state.is_enabled
		this.setState({ is_enabled: is_enabled })
		if (is_enabled) {
			this.props.handleChangeAV(this.state.av);
		} else {
			this.props.handleChangeAV(null);
		}
	}

	handleChangeAV = (val) => {
		if (this.state.is_enabled) {
			// Check for ''. This causes edit box to display 0 no matter what
			if (val == '') {
				this.setState({ av: val });
				this.props.handleChangeAV(0);
				return;
			}

			if (val == null) val = 0;
			else if (val < 0) val = 0;

			this.setState({ av: val });

			try {
				val = parseFloat(val);
			} catch (e) {
				val = 0;
			}
			this.props.handleChangeAV(val);
		} else {
			window.app.showToast(this.props.receiver.getString('no_enabled'), 3000);
			return;
		}
	}

	render() {
		let style = {
			textAlign: 'left',
			width: this.props.width - 40,
			marginTop: 10,
			marginLeft: 10,
			background: 'white',
			padding: 10,
			borderRadius: 20,
		}

		let step = 1;
		if (this.props.point_info != null) step = 1 / (Math.pow(10, this.props.point_info.ndp));

		const range = [];

		for (var i = this.min; i <= this.max; i += step) {
			if (parseFloat(this.state.av) == i) range.push(<option selected value={i}>{i.toFixed(1)}</option>);
			else range.push(<option value={i}>{i.toFixed(1)}</option>);
		}

		// Retrieve the unit for the selected management point
		let unit = '';
		if (this.props.point_id != null) {
			let point_info = window.app.state.point_list[this.props.point_id];
			if (point_info != null) {
				if (point_info.unit != null) {
					unit = point_info.unit;
				}
			}
		}

		return (
			<div style={style}>
				<div style={{ display: 'inline-block', verticalAlign: 'top' }}>
					<Switch style={{ display: 'inline-block', verticalAlign: 'top' }} is_enabled={this.state.is_enabled} handleToggleSwitch={this.handleToggleEnable} />
				</div>
				{/* Remove width by additional 20px - original : this.props.width-195 */}
				<div style={{ display: 'inline-block', verticalAlign: 'top', marginTop: 2, marginLeft: 5, width: this.props.width - 215 }}>
					<span>{this.props.receiver.getString('value')}</span>
				</div>
				<div style={{ display: this.props.point_info != null ? 'inline-block' : 'none', verticalAlign: 'top', width: 100, float: 'right' }}>
					<Select
						options={range}
						value={this.state.av}
						onSelect={this.handleChangeAV}
					/>
				</div>
				{/* Remove width limit of 100 to accomodate for the unit */}
				<div style={{ display: this.props.point_info == null ? 'inline-block' : 'none', verticalAlign: 'top', float: 'right' }}>
					<Editbox id='value' style={{ display: 'inline-block' }} inputStyle={{ width: unit == '' ? 100 : 80, marginTop: 0 }} inputType='number' onChange={(event) => this.handleChangeAV(event.target.value)} value={this.state.av} />
					<span id='unit' style={{ display: unit == '' ? 'none' : 'inline-block' }}>{unit}</span>
				</div>
			</div>
		)
	}
}